import type { ApiStorageLocation, EnumBusinessState } from '@Model';
import { enumBusinessStateOptions, getBadgeVariantByBusinessState, getEnumBusinessStateLabel } from '@Model';
import { Badge, Column } from '@synqo/frontend-component-library';

export const storageLocationColumns: Column<ApiStorageLocation>[] = [
    { name: 'number', label: 'Nummer' },
    { name: 'shorthand', label: 'Suchcode' },
    { name: 'label', label: 'Bezeichnung' },
    {
        name: 'business_state',
        label: 'Status',
        filterVariant: 'select',
        filterOptions: enumBusinessStateOptions,
        renderCell: ({ cellData }) => (
            <Badge variant={getBadgeVariantByBusinessState(cellData as EnumBusinessState)}>
                {getEnumBusinessStateLabel(cellData as EnumBusinessState)}
            </Badge>
        ),
    },
];
